import { SVGProps, Ref, forwardRef } from 'react';

export const AstrostarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m15.83 8.346.582.242.242.581C17.44 11.056 17.834 12 18.5 12s1.06-.944 1.846-2.83l.242-.582.58-.242C23.057 7.56 24 7.166 24 6.5s-.944-1.06-2.831-1.846l-.58-.242-.243-.581C19.56 1.944 19.166 1 18.5 1s-1.06.944-1.846 2.83l-.242.582-.581.242C13.943 5.44 13 5.834 13 6.5s.943 1.06 2.83 1.846M4.376 17.353l.898.374.374.898C6.862 21.54 7.47 23 8.5 23s1.638-1.459 2.853-4.375l.374-.898.898-.374C15.54 16.138 17 15.53 17 14.5s-1.459-1.638-4.375-2.853l-.898-.374-.374-.898C10.138 7.458 9.53 6 8.5 6s-1.638 1.458-2.853 4.375l-.374.898-.898.374C1.458 12.862 0 13.47 0 14.5s1.458 1.638 4.375 2.853"
                fill="currentColor"
            />
        </g>
    </svg>
));
AstrostarFilledSize24Glyph.displayName = 'AstrostarFilledSize24Glyph';
